export const SSN_ERROR_DUPLICATE_ACCOUNT = 'SSN_ERROR_DUPLICATE_ACCOUNT';

export const ssnErrorDuplicateAccount = (message) => ({
	type: SSN_ERROR_DUPLICATE_ACCOUNT,
	message,
});
